<template>
  <div>
    <main class="layout-main">
      <slot />
    </main>
    <footer class="main-footer">
      <NuxtLink to="/">
        <span class="sr-only">App Store homepage</span>
        <img
          class="main-footer__logo"
          alt=""
          width="126"
          height="38"
          src="~/assets/images/app-store-logo.svg"
        >
      </NuxtLink>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
$review-footer-height: 72px;

.layout-main {
  max-width: var(--app-layout-review-max-width);
  padding: 0 var(--app-layout-default-page-padding);
  margin: 0 auto;
  min-height: calc(100vh - $review-footer-height);
  display: grid;
  justify-self: center;
  align-items: center;
}

.main-footer__logo {
  margin: var(--app-spacer-12);

  @include min-width('lg') {
    margin-left: var(--app-spacer-44);
  }
}
</style>
